import React from 'react';
import CheckCircle from '../CheckCircle/CheckCircle';
import { Button } from '../../flayr-components';

interface ISuccessMsgProps {
  message?: React.ReactNode;
  className?: string;
  cta?: boolean;
  ctaLabel?: string;
  onCtaClick?: (e?: any) => void;
}

const SuccessMsg: React.FC<React.PropsWithChildren<ISuccessMsgProps>> = ({
  message,
  className,
  cta,
  ctaLabel = 'Close',
  onCtaClick,
}) => {
  return (
    <div className={`py-2 ${className}`}>
      <CheckCircle className="block mx-auto mb-4 text-5xl leading-tight text-green-500" />

      <div className="text-center">{message}</div>

      {cta && (
        <div className="mt-8">
          <Button onClick={onCtaClick} size="lg" color="dark" block>
            {ctaLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
export default SuccessMsg;
